<template>
  <div ref="scrollContainer" class="whole-div-PPC">
    <div style="height: 20px"></div>
    <!--      第一行-->
    <div class="div1-PPC">
      <div class="div1-div-PPC">
        <!--          muted:静音 autoplay:自动播放-->
        <video ref="videoPlayer" muted autoplay controls style="border-radius:15px;width: 100%" @ended="restartVideo">
          <source :src="productVideo" type="video/mp4">
        </video>
      </div>
    </div>
<!--    第二行-->
    <div class="div2-PFG">
      <a class="div2-a-PFG">
        <a class="div2-a-a-PFG"><i>Product Introduce / </i><strong> 产品介绍</strong></a>
        <br><br>
        致力于畜禽无害化处理智能设备与废气、废水处理设备的研发与生产
      </a>
    </div>
<!--    第三行-->
    <div class="div6-PFG" style="background-color: whitesmoke;">
      <div class="div6-div1-PFG">
        <div class="div6-div1-div1-PFG">
          <a class="div6-a1-PFG"><strong>畜禽无害化智能处理机</strong></a>
          <a class="div6-a2-PFG">
            &#12288;&#12288;畜禽无害化智能处理机,对病死畜禽及其制品主要采取干化法分类进行无害化处理，通过高温裂解，将病原体完全杀灭，并使油脂融化和蛋白质凝固，经化制后的油脂可用于工业用油；肉骨粉可用于有机肥料加工的原材料。<br>
            &#12288;&#12288;生产过程中产生的废气，经配套处理后达到国家排放标准，确保无废水、无废气、无废渣，杜绝二次污染源的产生，并达到零排放；保证畜产品质量的安全及人民群众的身体健康，是畜禽无害化处理的优质产品！
          </a>
        </div>
        <div class="div6-div1-div2-PFG">
          <img :src="productImg" title="畜禽无害化智能处理机" alt="" width="100%" height="100%">
        </div>
      </div>
    </div>
    <div style="height: 30px;background-color: whitesmoke"></div>
<!--    第四行：质量保证-->
    <div class="div5-PFG">
      <a class="div5-a-PFG">
        <a class="div5-a-a-PFG"><i>Quality Assurance / </i><strong> 质量保证</strong></a>
        <br><br>
        可靠的质量&#12288;用心的服务
      </a>
    </div>
<!--    第五行：质量保证的内容-->
    <div class="div3-PFG">
      <!--      公司图片+公司介绍-->
      <div class="div3-div1-PFG" style="background-color: #FFFFFF">
        <div class="div3-div1-div1-PFG">
          <img :src="qualityImg" alt="" width="100%" height="100%">
        </div>
        <div class="div3-div1-div2-PFG">
          <a class="div3-a1-PFG" style="font-size: 25px"><strong>本公司为广大用户郑重承诺</strong></a>
          <a class="div3-a2-PFG" style="font-size: 20px;">
            一、将以最短时间、最快速度、到达现场，全天候服务于用户<br>
            &#12288;&#12288;&#12288;浙江省内24小时到达现场；<br>
            &#12288;&#12288;&#12288;浙江省外30小时到达现场。<br><br>
            二、实行跟踪服务<br><br>
            三、为用户免费提供技术培训<br>
          </a>
        </div>
      </div>
    </div>
    <div style="height: 30px"></div>

    <!-- 第9行：底框 -->
    <div class="div9-PFG">
      <div style="width: 25%;height: 100%"></div>
      <div class="div9-div1-PFG">
        <img src="../../public/image/浙江纵海.jpg" alt="" height="80%">
      </div>
      <div class="div9-div2-PFG">
        <div style="width: 60%;position: relative;text-align: left">
          <a style="font-size: 20px;font-weight: bold;">联系方式</a><br><br>
          <a >联系人：{{this.$store.state.contactIntroduce.personName}}</a><br>
          <a >手机号码：{{this.$store.state.contactIntroduce.phoneNumber}}</a><br>
          <a>电话号码：{{this.$store.state.contactIntroduce.telephoneNumber}}</a><br>
          <a>地址：{{this.$store.state.contactIntroduce.address}}</a><br>
          <a>邮箱：{{this.$store.state.contactIntroduce.email}}</a>
        </div>
      </div>
      <div class="div9-div3-PFG">
        <div style="text-align: left">
          <a style="font-family: Avenir">Copyright © 2024</a><br><br>
          <a>版权所有©浙江纵海自动化设备有限公司</a><br>
          <a class="div9-div3-a1-PFG" href="https://beian.miit.gov.cn/" target="_blank">{{this.$store.state.contactIntroduce.recordNumber}}</a><br>
          <a class="div9-div3-a1-PFG" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33108202000840" target="_blank">{{this.$store.state.contactIntroduce.policeRecordNumber}}</a><br><br>
          <a>声明:本站部分数据来源于互联网,与本公司无关,若有侵权请联系客服删除。</a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import '../css/pc/PPC_PcProductCenter.css'

  export default {
    name: "PcProductCenter",
    data() {
      return {
        //质量保证图片
        qualityImg: require('../../public/image/质量保证.jpg'),
        //产品视频
        productVideo: require('../../public/video/产品介绍.mp4'),
        //产品图片
        productImg: require('../../public/image/首页图片1.jpg'),
      }
    },
    mounted(){

    },
    methods: {
      //滚动置顶方法
      scrollToTop(){
        const position=0;
        this.$refs.scrollContainer.scrollTop=position;
      },
      //让视频一直播放
      restartVideo() {
        // 当视频结束时，将当前播放时间设置为0，实现重新开始
        this.$refs.videoPlayer.currentTime = 0;
        // 播放视频
        this.$refs.videoPlayer.play();
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/computer/PcProductCenter.vue